import React, { useState, useMemo } from 'react';
import MqttChart from '../mqtt/MqttChart';
import OverlayChart from '../mqtt/OverlayChart';
import '../../styles/actions.css';

function ThresholdTestDemo() {
    const [isChartOverlay, setIsChartOverlay] = useState(false);

    const mockSensorData = useMemo(() => {
        const data = [];
        const now = new Date();
        for (let i = 0; i < 24; i++) {
            const timestamp = new Date(now.getTime() - (23 - i) * 60 * 60 * 1000);
            // Simulate humidity data that crosses thresholds
            const humidity = 50 + 30 * Math.sin(i * 0.5) + Math.random() * 10; // 20-90 range
            data.push({
                timestamp: timestamp.toISOString(),
                humidity: Math.max(10, Math.min(90, humidity)) // Clamp between 10-90
            });
        }
        return data;
    }, []);

    const mockActionData = useMemo(() => {
        const data = [];
        const now = new Date();
        for (let i = 0; i < 24; i++) {
            const timestamp = new Date(now.getTime() - (23 - i) * 60 * 60 * 1000);
            // Irrigation more active when humidity is low
            const humidity = mockSensorData[i]?.humidity || 50;
            const isActive = humidity < 40 ? (Math.random() > 0.3 ? 1 : 0) : (Math.random() > 0.8 ? 1 : 0);
            data.push({
                timestamp: timestamp.toISOString(),
                irrigation: isActive
            });
        }
        return data;
    }, [mockSensorData]);

    const mockThresholds = {
        low: 30,    // Blue line
        high: 70    // Red line
    };

    return (
        <div style={{ padding: '2rem', background: '#1a1a1a', minHeight: '100vh' }}>
            <h1 style={{ color: 'white', textAlign: 'center', marginBottom: '2rem' }}>
                Threshold Test Demo
            </h1>

            <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                <button 
                    onClick={() => setIsChartOverlay(!isChartOverlay)}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: isChartOverlay ? '#4CAF50' : '#333',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    {isChartOverlay ? 'Show Separate Charts' : 'Show Overlay Chart'}
                </button>
            </div>

            <div style={{ 
                background: '#2a2a2a', 
                borderRadius: '10px', 
                padding: '2rem',
                marginBottom: '2rem'
            }}>
                <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '1rem' }}>
                    Humidity Sensor + Irrigation Status
                </h2>
                <p style={{ color: 'lightgray', textAlign: 'center', marginBottom: '2rem' }}>
                    Expected Thresholds: Low=30% (blue), High=70% (red)
                </p>

                {isChartOverlay ? (
                    <div>
                        <h3 style={{ textAlign: 'center', marginBottom: '1rem', color: 'white' }}>
                            🔗 Overlay Chart (Should Show Thresholds)
                        </h3>
                        <OverlayChart 
                            sensorType="Humidity"
                            actionType="Irrigation"
                            sensorHistoricalData={mockSensorData}
                            actionHistoricalData={mockActionData}
                            sensorThresholds={mockThresholds}
                            selectedTimeRange="1d"
                        />
                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                        <div>
                            <h3 style={{ textAlign: 'center', marginBottom: '1rem', color: 'white' }}>
                                📊 Humidity Sensor (Should Show Thresholds)
                            </h3>
                            <MqttChart 
                                sensorType="Humidity"
                                historicalData={mockSensorData}
                                thresholds={mockThresholds}
                                selectedTimeRange="1d"
                            />
                        </div>
                        <div>
                            <h3 style={{ textAlign: 'center', marginBottom: '1rem', color: 'white' }}>
                                🚿 Irrigation Status
                            </h3>
                            <MqttChart 
                                sensorType="Irrigation"
                                historicalData={mockActionData}
                                selectedTimeRange="1d"
                            />
                        </div>
                    </div>
                )}
            </div>

            <div style={{ 
                background: '#2a2a2a', 
                borderRadius: '10px', 
                padding: '2rem',
                color: 'lightgray'
            }}>
                <h3 style={{ color: 'white', marginBottom: '1rem' }}>Debug Info:</h3>
                <ul>
                    <li>Mock sensor data: {mockSensorData.length} points</li>
                    <li>Mock action data: {mockActionData.length} points</li>
                    <li>Low threshold: {mockThresholds.low}%</li>
                    <li>High threshold: {mockThresholds.high}%</li>
                    <li>Check browser console for threshold debug logs</li>
                </ul>
            </div>
        </div>
    );
}

export default ThresholdTestDemo;
